import {
  isPermittedByGate,
  type PermissionGateSpec,
} from 'features/permissions/utils/isPermittedByGate'
import type { RolodexPermissionsValues } from 'types'

export function isSidebarNavItemPermitted({
  chatLayout,
  hasPermissions,
  gate,
}: {
  chatLayout: boolean
  hasPermissions: (permissions: RolodexPermissionsValues[]) => boolean
  gate: PermissionGateSpec
}): boolean {
  return !chatLayout || isPermittedByGate(hasPermissions, gate)
}
